module.exports = __webpack_public_path__ + "img/share.c0c6c9aa.svg";